import { Observation } from "@medplum/fhirtypes";

export function getObservationValue(observation: Observation): string {
  if (observation.valueQuantity) {
    const unit = observation.valueQuantity.unit?.replace(/[{()}]/g, "") ?? "";
    return `${observation.valueQuantity.value ?? ""} ${unit}`.trim();
  } else if (observation.valueString) {
    return observation.valueString;
  } else if (observation.valueCodeableConcept) {
    return (
      observation.valueCodeableConcept.text ||
      observation.valueCodeableConcept.coding?.[0]?.display ||
      "-"
    );
  }
  return "-";
}
